import { GlobalState } from '@leverege/ui-redux';
import { R } from '@leverege/value-resolver';
import QS from 'query-string';
import { History } from '@leverege/molten-core';
import Util from "./Util.js";
const {
  parse,
  stringify
} = QS;

/**
 * This will create a action that will set the url to ths given path. The path
 * will be resolved based off of the given context.clientProps.match.params.
 * In particular, a path of /building/:buildingId might be resolved to '/building/5'
 * if params contains { buildingId : 5 }.
 * 
 * To work correctly, the clientProps must be given in the context.
 * 
 * @param {string} opts.id the plugin id to use
 * @param {string} opts.name the name to present to the user
 * @param {object} opts.matches the action matches criteria
 * @param {object} [opts.layout] the action layout options
 * @param {string} opts.path the url path
 * @param {string} [opts.icon] the icon to use
 * @param {string} [opts.iconOn] the on icon to use
 * @param {string} [opts.iconOff] the off icon to use
 * @param {string} [opts.handles] option handles. default returns true
 */
const create = ({
  id,
  matches,
  path,
  layout,
  handles,
  prepare,
  isPrepared,
  name,
  icon,
  iconOn,
  iconOff,
  startsWith = true,
  matchQuery = false,
  query
}) => {
  return {
    id,
    matches,
    path,
    startsWith,
    layout,
    handles: handles || alwaysTrue,
    prepare,
    isPrepared,
    appearance: ({
      context,
      action
    }) => {
      const {
        match
      } = context.clientProps || {};
      const rPath = History.adjustPath(match ? Util.resolve(path, match) : path);
      const cPath = GlobalState.get().router?.location.pathname;
      let checked = startsWith ? cPath.startsWith(`${rPath}/`) || cPath === rPath : cPath === rPath;
      if (checked && matchQuery) {
        const qString = GlobalState.get().router?.location.search;
        const q = parse(qString);
        if (query) {
          Object.entries(query).forEach(([key, value]) => {
            if (q[key] !== value) {
              checked = false;
            }
          });
        }
      }
      return {
        name: R(name),
        icon: R(icon),
        iconOn: R(iconOn),
        iconOff: R(iconOff),
        checkStyle: 'toggle',
        checked
      };
    },
    perform: ({
      context
    }) => {
      const {
        clientProps: {
          dispatch = GlobalState.dispatch,
          match
        },
        onClose
      } = context;
      const p = query ? `${path}?${stringify(query)}` : path;
      const rPath = Util.resolve(p, match);
      dispatch(History.push(rPath));
      if (onClose) onClose();
    }
  };
};
function alwaysTrue() {
  return true;
}
export default {
  create
};